<template>
    <div class="marketing-plan-insert-widget">
        <div class="widget-header">
            <h3>Add Template or Email?</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div v-if="isLoading" class="loading-container">
            <loading-screen-svg />
        </div>
        <div v-else class="content-wrapper">
            <div class="select-container">
                <div class="title">Would you like add a Marketing Plan Template, or an email?</div>
                <div class="choice-container">
                    <app-input-radio 
                        v-model="selectedOption"
                        :options="options"
                        horizontal
                        centered />
                </div>
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="cancel-btn" @click="closeWidget">
                    Cancel
                </app-button>
            </div>
            <div class="action-container">
                <app-button class="save-btn" @click="next()">
                    Next
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const AppInputRadio = () => import('@/components/common/app-input-radio');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'marketing-plan-insert-widget',

    props: {
        widget: {
            type: Object   
        }
    },

    components: {
        'app-input-radio': AppInputRadio,
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
        'loading-screen-svg': LoadingScreenSvg,
    },

    data() {
        return {
            startDate: this.widget.startDate,
            options: [{
                name: 'Campaign',
                imageUrl: require('@/assets/images/non-graphical-email.png')
            }, {
                name: 'Marketing Plan Template',
                imageUrl: require('@/assets/images/marketing-plan.png')
            }],

            selectedOption: null,
            marketingPlanId: this.widget.marketingPlanId,
            isLoading: false,
        }
    },

    computed: {
        
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
        
        next() {
            if (this.selectedOption === this.options[0]) {
                EventBus.$emit('open-widget', { 
                    name: 'campaign-widget',
                    clientId: this.widget.clientId,
                    marketingPlanId: this.marketingPlanId,
                    sendDate: this.startDate
                });

                this.closeWidget();
            }
            else {
                EventBus.$emit('open-widget', { 
                    name: 'marketing-plan-template-select-widget',
                    clientId: this.widget.clientId,
                });              
            }
        },

        adoptTemplate(template) {
            this.isLoading = true;

            var request = {
                MarketingPlanTemplateId: template.id,
                StartDate: this.startDate
            };

            this.$api
                .post(`/api/MarketingPlans/${ this.marketingPlanId }/Adopt`, request)
                .then(() => {
                    this.$helpers.showSuccessNotification(`Template successfully inserted.`);
                    EventBus.$emit('marketing-plan:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification(`Error inserting template.`, { error });
                })
        }
    },

    created() {
        this.selectedOption = this.options[0];
        EventBus.$on('marketing-plan-template:select', this.adoptTemplate);
    },

    beforeDestroy() {
        EventBus.$off('marketing-plan-template:select', this.adoptTemplate);
    }
}
</script>

<style >
.marketing-plan-insert-widget .action-container .save-btn {
    width: 128px;
}

.marketing-plan-insert-widget .action-container .back-btn {
    width: 128px;
    background: transparent;
    color: #18AEFF;
    margin-right: 10px;
}

.marketing-plan-insert-widget .action-container .back-btn:hover {
    background: #E1E0E5;
}

.marketing-plan-insert-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.marketing-plan-insert-widget .cancel-btn:hover {
    background: #E9E9EF;
}

.marketing-plan-insert-widget .select-container {
    position: relative;
    border: 2px solid #E9E9EF;
    border-radius: 22px;
    margin-bottom: 25px;
}

.marketing-plan-insert-widget .select-container .title {
    position: absolute;
    top: -11px;
    left: 50px;
    padding: 0px 25px;
    background-color: #FFFFFF;
    font-weight: 600;
}

.marketing-plan-insert-widget .select-container .app-input-radio .option {
    display: flex;
    justify-content: space-between;
}

.marketing-plan-insert-widget .select-container .choice-container .option-image {
    width: 260px;
    height: auto;
}

.marketing-plan-insert-widget .app-input-radio .option .radio-option-label {
    font-weight: 600;
}
</style>
